class BsImageComponent {

  constructor() {}

  init() {
    this.$element = document.querySelector('div.image-component');

    if (!this.$element) return;

    this.$action = this.$element.querySelector('input[name="image-action"]');
    this.$existsGroup = this.$element.querySelector('.image-exists-group');
    this.$uploadGroup = this.$element.querySelector('.image-upload-group');
    this.$removeButton = this.$element.querySelector('a.image-remove');
    this.$cancelButton = this.$element.querySelector('a.image-cancel');
  }

  toggleGroups() {
    if (this.$existsGroup.classList.contains('d-none')) {
      this.$existsGroup.classList.remove('d-none');
      this.$uploadGroup.classList.add('d-none');
    } else {
      this.$existsGroup.classList.add('d-none');
      this.$uploadGroup.classList.remove('d-none');
    }
  }

  setupEvents() {

    if (!this.$element) return;

    let _this = this;

    this.$removeButton.addEventListener('click', function (event) {
      event.preventDefault();
      _this.toggleGroups();
      _this.$action.value = 'remove';
      return false;
    });

    this.$cancelButton.addEventListener('click', function (event) {
      event.preventDefault();
      _this.toggleGroups();
      _this.$action.value = '';
      return false;
    });
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new BsImageComponent();